module.exports = __webpack_public_path__ + "fonts/iconfont.10ab7e8.svg";